<template>
  <div style="height: 80px;width: 300px;">
    <div class="progress progress-review">
      <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" :style="{ width: progressBarWidth }"></div>
      <div class="proPoint proPoint1" :class="{ active: activeIndex >= 0 }">
        <i :class="{ no: isPass === false && noPassIndex === 0 }">1</i>
        课题申报
        <span v-if="isPass === false && hint !== '' && noPassIndex === 0">{{ hint }}</span>
      </div>
      <div class="proPoint proPoint2" :class="{ active: activeIndex >= 1 }">
        <i :class="{ no: isPass === false && noPassIndex === 1 }">2</i>
        校审核
        <span v-if="isPass === false && hint !== '' && noPassIndex === 1">{{ hint }}</span>
      </div>
      <div class="proPoint proPoint3" :class="{ active: activeIndex >= 2 }">
        <i :class="{ no: isPass === false && noPassIndex === 2 }">3</i>
        区审核
        <span v-if="isPass === false && hint !== '' && noPassIndex === 2">{{ hint }}</span>
      </div>
      <div class="proPoint proPoint4" :class="{ active: activeIndex >= 3 }">
        <i :class="{ no: isPass === false && noPassIndex === 3 }">4</i>
        评审
        <span v-if="isPass === false && hint !== '' && noPassIndex === 3">{{ hint }}</span>
      </div>
      <div class="proPoint proPoint5" :class="{ active: activeIndex >= 4 }">
        <i :class="{ no: isPass === false && noPassIndex === 4 }">5</i>
        立项
        <span v-if="isPass === false && hint !== '' && noPassIndex === 4">{{ hint }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      progressBarWidth: '20%',
      activeIndex: 0,
      isPass: true,
      noPassIndex: 0,
      hint: ''
    };
  },
  watch: {
    status(val) {
      if (val) { this.init(); }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.status == 0) {
        this.progressBarWidth = '0%';
        this.activeIndex = 0;
        this.isPass = false;
      } else if (this.status == 1) {
        this.progressBarWidth = '25%';
        this.activeIndex = 0;
        this.isPass = true;
      } else if (this.status == 2) {
        this.progressBarWidth = '25%';
        this.activeIndex = 1;
        this.isPass = false;
        this.noPassIndex = 1;
        this.hint = '退回修改';
      } else if (this.status == 3) {
        this.progressBarWidth = '25%';
        this.activeIndex = 1;
        this.isPass = false;
        this.noPassIndex = 1;
        this.hint = '不通过';
      } else if (this.status == 4) {
        this.progressBarWidth = '50%';
        this.activeIndex = 1;
        this.isPass = true;
      } else if (this.status == 5) {
        this.progressBarWidth = '50%';
        this.activeIndex = 2;
        this.isPass = false;
        this.noPassIndex = 2;
        this.hint = '退回修改';
      } else if (this.status == 6) {
        this.progressBarWidth = '50%';
        this.activeIndex = 2;
        this.isPass = false;
        this.noPassIndex = 2;
        this.hint = '不通过';
      } else if ([7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].includes(this.status)) {
        this.progressBarWidth = '75%';
        this.activeIndex = 2;
        this.isPass = true;
      } else if (this.status == 21) {
        this.progressBarWidth = '75%';
        this.activeIndex = 3;
        this.isPass = true;
      } else if (this.status == 22) {
        //立项审核未处理
        this.progressBarWidth = '100%';
        this.activeIndex = 3;
        this.isPass = true;
      } else if (this.status == 23) {
        //立项
        this.progressBarWidth = '100%';
        this.activeIndex = 4;
        this.isPass = true;
      } else if (this.status == 24) {
        //不立项
        this.progressBarWidth = '100%';
        this.activeIndex = 4;
        this.isPass = false;
        this.noPassIndex = 4;
        this.hint = '不立项';
      }
    },
  }
};
</script>

<style scoped lang="scss">
.progress {
  line-height: 18px;
}

.progress-review {
  margin: 30px 30px 30px;
}

.proPoint {
  text-align: center;

  span {
    position: absolute;
    top: -65px;
    left: 50%;
    transform: translateX(-50%);
    display: block;
    white-space: nowrap;
    color: red;
  }
}
</style>
